import { UseEntityOptions } from "@hakit/core";

export function DummyComponentOptions(props: Partial<UseEntityOptions>) {
  return props;
}
